import { render, staticRenderFns } from "./Billboard.vue?vue&type=template&id=0c962722&scoped=true&"
import script from "./Billboard.vue?vue&type=script&lang=js&"
export * from "./Billboard.vue?vue&type=script&lang=js&"
import style0 from "./Billboard.vue?vue&type=style&index=0&id=0c962722&lang=scss&scoped=true&"
import style1 from "./Billboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c962722",
  null
  
)

export default component.exports